jQuery( document ).ready( function() {
	// Get all div elements with the class 'left-column-divs' and 'right-column-divs'
	const leftDivsTarget = jQuery( '.left-column-divs' );
	const rightDivsTarget = jQuery( '.right-column-divs' );

	// Count the number of these divs
	const leftDivsCount = leftDivsTarget.length;
	const rightDivsCount = rightDivsTarget.length;

	// Function to show the first 'n' divs of a given class
	function showDivs( target, count ) {
		target.slice( 0, count ).show();
	}

	// Initially show the first 6 divs of each class
	showDivs( leftDivsTarget, 6 );
	showDivs( rightDivsTarget, 6 );

	// Click event for the 'Load More' button
	let leftDivsShown = 6;
	let rightDivsShown = 6;

	jQuery( '.news-ajax-loadmore-both' ).click( function() {
		leftDivsShown += 6;
		rightDivsShown += 6;
		showDivs( leftDivsTarget, leftDivsShown );
		showDivs( rightDivsTarget, rightDivsShown );

		// Hide the button if all divs are shown
		if ( leftDivsShown >= leftDivsCount && rightDivsShown >= rightDivsCount ) {
			jQuery( this ).hide();
		}
	} );

	// Initially hide the button if there are less than or equal to 6 divs in each column
	if ( leftDivsCount <= 6 && rightDivsCount <= 6 ) {
		jQuery( '.news-ajax-loadmore' ).hide();
	}
} );

// jQuery( document ).ready( function() {
// 	// Get all div elements with the class 'hide-this'
// 	const leftDivsTaget = jQuery( '.left-column-divs' );
// 	const rightDivsTaget = jQuery( '.right-column-divs' );

// 	// Count the number of these divs
// 	const leftDivs = leftDivsTaget.length;
// 	const rightDivs = rightDivsTaget.length;

// 	// Display the count
// 	console.log( "Number of divs with class 'hide-this': " + leftDivs );
// } );

// jQuery( document ).on( 'click', '.news-ajax-loadmore', function() {
// 	const element = jQuery( this );
// 	const pages = element.attr( 'data-pages' );
// 	let page = parseInt( element.attr( 'data-page' ) );
// 	const category = element.attr( 'data-category' );
// 	// console.log( page, pages, featured );
// 	element.text( 'Loading.....' );
// 	jQuery( '.news-ajax-loadmore-both' ).text( 'Loading.....' );
// 	jQuery.ajax( {
// 		url: localVars.ajax_url,
// 		type: 'POST',
// 		data: {
// 			action: 'news_loadmore',
// 			category,
// 			pages,
// 			page,
// 			nonce: localVars.nonce,
// 		},
// 		success( response ) {
// 			if ( page <= pages ) {
// 				page++;
// 				element.attr( 'data-page', page );
// 				jQuery( '#news-ajax-response[data-category="' + category + '"]' ).append( response );
// 				element.text( 'Load More' );
// 				jQuery( '.news-ajax-loadmore-both' ).text( 'Load More' );
// 				if ( page > pages ) {
// 					element.hide();
// 					jQuery( '.news-ajax-loadmore-both' ).addClass( category );
// 				}
// 			}
// 		},
// 		error() {
// 			element.text( 'Load More' );
// 			jQuery( '.news-ajax-loadmore-both' ).text( 'Load More' );
// 		},
// 	} );
// } );

// jQuery( document ).on( 'click', '.news-ajax-loadmore-both', function() {
// 	jQuery( '.news-ajax-loadmore' ).each( function() {
// 		jQuery( this ).click();
// 	} );
// } );
